import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';
import { getTextForOptions } from '@artemis/containers/Cart/utils';
import { CartItemShape } from './propTypes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ItemName = styled.h3`
  ${props => props.theme.typography.body};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
`;

const ItemNote = styled.p`
  color: ${props => props.theme.palette.grey[400]};
  ${props => props.theme.typography.subtitle2};
  font-style: italic;
`;

const Option = styled.div`
  color: ${props => props.theme.palette.grey[600]};
  ${props => props.theme.typography.caption};
`;

const OriginalPrice = styled.p`
  color: ${props => props.theme.palette.grey[600]};
  ${props => props.theme.typography.caption};
`;

const ItemDetails = ({ item, currencyCode, className }) => (
  <Container className={className}>
    <ItemName>{item.title}</ItemName>
    <Option>
      {getTextForOptions({ options: item.cartItemOptions, currencyCode })}
    </Option>
    <ItemNote>{item.note}</ItemNote>
    {item.perk && (
      <OriginalPrice>
        <FormattedMessage
          entry="cart.perk.originalPrice"
          values={{ price: item.perk.originalPrice }}
        />
      </OriginalPrice>
    )}
  </Container>
);
ItemDetails.propTypes = {
  item: CartItemShape,
  currencyCode: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ItemDetails;
